import {Colors} from './colors';

export class QuestionnaryModel
{
	id: number = undefined;
	name: string = undefined;
	description: string = undefined;
	pointManager: string = undefined;
  disableunrevelant: boolean = false;

	slices: Array<any>;


	constructor(values: Object) {
	   if(values) this.exchange(values);
	}
	exchange(values: Object = {}) {
	    for (let p in values) {
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}

		    	this[p] = values[p];

		    }
		    else if(p=='pointmanager') this.pointManager = values[p];
		}

		this.prepareSlices(this.pointManager);
	}

	prepareSlices(points)
	{
		let slicesName   = ['Alarmant', 'Préocupant', 'Important', 'Positif'];
		let slicesColors = Colors.colors;
		this.slices = [];

		this.slices[0] = {
			name: '',
			color: 'white'
		}

		let pointmanager = points.split(',').reverse();
		for (var i = 0; i <= pointmanager.length - 1; i++) {
			let minMax = pointmanager[i].split('-');
			let min = parseInt(minMax[0]);
			let max = parseInt(minMax[1]);
			for(var t:number=min;t<=max;t++) {
				this.slices[t] = {
					name: slicesName[i],
					color: slicesColors[i]
				}
			}
		}
	}


	getSlice(score)
	{
		if(this.slices==undefined) {
			if(this.pointManager!=undefined) this.prepareSlices(this.pointManager);
			else return null;
		}

		if(!score) score = 0;
		score = Math.round(score);

		return this.slices[score];
	}


	toString()
	{
		return "quesionnary.model "+this.name;
	}
}
